module.exports = __webpack_public_path__ + "static/media/copy.b617f779.svg";